
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import Loading from "../../Component/Loading/Loading";
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import API from "../../Services/BaseService";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import StateAndCity from '../../Component/StateAndCity/StateAndCity';
import RemoveIcon from '../../assets/img/error.svg'
import { remove } from 'local-storage';
import StateAndCitySearch from '../../Component/StateAndCity/StateAndCitySearch';
import PageNotFound from '../FallBackUI/PageNotFound';
import { Button } from 'antd';
import { Modal } from 'react-bootstrap';

const URpost = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const { flagFilter, selectSellerId } = props.location.state;
    const [carCount, setCarCount] = useState(1);
    const [switchAddress, setSwitchAddress] = useState("same");
    const [VINNumber, setVINNumber] = useState("");
    const [VINNumber1, setVINNumber1] = useState("");

    const [year, setYear] = useState("");
    console.log("VINNumber", VINNumber1);
    const [make, setMake] = useState("");
    console.log("setMake 1233", make);
    const [comments, setComments] = useState("");
    console.log("carCount", carCount)

    const [model, setModel] = useState("");
    const [salesId, SetSalesId] = useState();
    const [selectDays, setSelectDays] = useState("");
    const [product, setProduct] = useState([]);
    const [createSelectItems, setCreateSelectItems] = useState();
    const [SalesIdError, SetSalesIdError] = useState("");
    const [noOfDaysError, setNoOfDaysError] = useState("");
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [popupFlag, setPopupFlag] = useState(true);

    const [isOpen, setIsOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [address, setAddress] = useState("");
    const [stateName, setStateName] = useState(null);
    const [cityName, setCityName] = useState(null);
    const [zipCodeId, setZipcodeId] = useState(null);
    const [stateCityFlag, setStateCityFlag] = useState("");

    const sellerData = useSelector(state => state.LoginReducer.payload);
    const dealerData = useSelector(state => state.DealerReducer.payload);

    const [currentState, setCurrentState] = useState("");
    const [currentCity, setCurrentCity] = useState("");
    const [currentZip, setCurrentZip] = useState("");
    const [currentStateId, setCurrentStateId] = useState(null);
    const [currentCityId, setCurrentCityId] = useState(null);
    const [currentZipId, setCurrentZipId] = useState(null);
    const [carDataList, setCarDataList] = useState([]);
    const [selectedBid, setSelectedBid] = useState(null);
    const [selectedDays, setSelectedDays] = useState(null);
    const [carDataListdecode, setCarDataListdecode] = useState([]);
    const [carDataListDays, setCarDataListDays] = useState([]);
    const [VINDisableFlag, setVINDisableFlag] = useState(false)
    console.log("VINDisableFlag", VINDisableFlag)
    const [vinNoChecking, setVinNoChecking] = useState("");
    const [DecodeError, setDecodeError] = useState("");


    const [carCountError, setCarCountError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [VINInvalidError, setVINInvalidError] = useState("");
    const [VinNoError, setVinNoError] = useState("");
    const [stateAndCityError, setStateAndCityError] = useState("");

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    const [decodeflage, setDecodeflage] = useState(false);
    const [bidAndDayFlag, setBidAndDayFlag] = useState(false);
    console.log("carDataList", carDataList)

    const [confirmationFlag, setConfirmationFlag] = useState(false);
    const [changesArray, setChangesArray] = useState([]);
    console.log("changesArray", changesArray)
    const confirmationPopup = () => {

        setConfirmationFlag(!confirmationFlag)

    }

    const customButtonStyle = {
        backgroundColor: "RGB(189,6,44)",
        color: "white",
        height: '40px'
    };


    useEffect(() => {
        let request = {
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,
        };
        const state = API.post('urpostSellerProfile/condition', request);
        state.then(res => {
            if (res.data.success === true) {
                if (res.data.success) {
                    setCurrentState(res.data.data[0].sellerStateName);
                    setCurrentCity(res.data.data[0].sellerCityName);
                    setCurrentZip(res.data.data[0].sellerZipcode);

                    setCurrentStateId(res.data.data[0].state_id);
                    setCurrentCityId(res.data.data[0].city_id);
                    setCurrentZipId(res.data.data[0].zipcode_id);
                    setLoading(false);

                }
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }, [])

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }
    const toggleCommonPopup = () => {
        setOpen(!open);
    }
    const getStateName = (stateData, flag, type) => {
        setStateName(stateData)
        setStateCityFlag(flag)
        if (flag === "") {
            setCityName(null)
            setZipcodeId(null)
        }
        const oldValue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { oldvalue: oldValue, newvalue: stateData, name: type };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldValue, newvalue: stateData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getCityName = (cityData, flag, type) => {
        setCityName(cityData)
        if (flag === "") {
            setZipcodeId(null)
        }
        const oldValue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = {
                    ...updatedChangesArray[existingChangeIndex],
                    newvalue: cityData,
                };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldValue, newvalue: cityData, name: type };
                return [...prevChangesArray, change];
            }
        });
    }

    const getZipCodeId = (zipData, flag, type) => {
        setZipcodeId(zipData)
        const oldValue = "";
        setChangesArray((prevChangesArray) => {
            const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
            const updatedFlag = flag || 'dropdown';
            if (existingChangeIndex !== -1) {
                const updatedChangesArray = [...prevChangesArray];
                updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData, flag: updatedFlag };
                return updatedChangesArray;
            } else {
                const change = { oldvalue: oldValue, newvalue: zipData, name: type, flag: updatedFlag };
                return [...prevChangesArray, change];
            }
        });
    }

    const getError = (data, flag) => {
        setErrors(data)
        setErrorFlag(flag)
    }
    const handleSubmit1 = (event, props, data) => {
        event.preventDefault();
        setCarCountError("")
        setVINInvalidError("")
        setAddressError("");
        setStateAndCityError("")
        setDecodeError("")
        SetSalesIdError("")
        setNoOfDaysError("")

        // setVinNoError("")
        const ONLY_DIGITS_REGEXP = /^\d+$/;
        if (carCount === "") {
            setCarCountError("Car count is required");
            return;
        }
        // else if (carCount != carDataList.length) {
        //     setCarCountError("Selected Cars are not added");
        //     return;
        // }
        else if (!ONLY_DIGITS_REGEXP.test(carCount)) {
            setCarCountError("Car count accept only number");
            return;
        } else if (carCount < 1 && carCount > 100) {
            setCarCountError("Car count accept only 1 to 100 cars");
            return;
        }
        if (switchAddress !== "same") {
            if (address === "") {
                setAddressError("Address is required");
                return;
            }
            if (!stateName) {
                setStateAndCityError("1")
                return;
            }
            if (!cityName) {
                setStateAndCityError("2")
                return;
            }
            if (!zipCodeId) {
                setStateAndCityError("3")
                return;
            }
        }
        if (year == "" && make == "" && model == "" && VINNumber.length > 0 && carCount === "") {
            setDecodeError("Decode is Required")
            return;
        }
        setConfirmationFlag(true)
    }
    const handleSubmit = (event, props, data) => {
        const emptyRecordsCount = Math.max(carCount - carDataList.length, 0);
        const emptyRecords = Array.from({ length: emptyRecordsCount }, () => ({
            vin_no: "",
            model: "",
            make: "",
            year: "",
            sales_type_id: "",
            no_of_days: ""
        }));

        const updatedCarDataList = [...carDataList, ...emptyRecords];
        const filteredChangesflag = changesArray.length > 0 ? "yes" : "no"

        let request = {
            historylist: changesArray,
            valuechanges: filteredChangesflag,
            seller_dealer_id: data == undefined ? dealerData !== null ? dealerData.seller_dealer_id : sellerData.seller_dealer_id : data,
            no_cars: carCount,
            address: switchAddress === "same" ? sellerData.address : address,
            state_id: stateCityFlag === "" ? switchAddress === "same" ? currentStateId : stateName : "",
            city_id: stateCityFlag === "" ? switchAddress === "same" ? currentCityId : cityName : "",
            zipcode_id: stateCityFlag === "" ? switchAddress === "same" ? currentZipId : zipCodeId : "",
            state_name: stateCityFlag !== "" ? stateName : "",
            city_name: stateCityFlag !== "" ? cityName : "",
            zipcode: stateCityFlag !== "" ? zipCodeId : "",
            active: 1,
            carList: updatedCarDataList,
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,
            urpost_comments: comments
        };
        console.log("request", request);
        // return
        API.post("urpost/add", request)
            .then((response) => {
                console.log("")
                if (response.data.success) {
                    const { data } = response;
                    console.log("response", response)
                    togglePopup()
                    setPopupTitle("");
                    setPopupMsg("Thank you so much for your Business! We will be gald to sell your car");
                    setPopupType("success");
                    setPopupActionType("redirect");
                    setPopupActionValue("ok");
                    setPopupActionPath("/urpostlist")

                } else {
                    togglePopup()
                    setPopupTitle("Error");
                    setPopupMsg(response.data.error.err);
                    setPopupActionType("close");
                    setPopupActionValue("close");
                }
            }, (error) => {
                togglePopup()
                setPopupTitle("Error");
                setPopupMsg("Something went wrong, Please try Again");
                setPopupType("error");
                setPopupActionType("close");
                setPopupActionValue("close");
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    const getSearch = () => {
        document.getElementById('vinNo').Value = "";
        document.getElementById('year').Value = "";
        document.getElementById('make').Value = "";
        document.getElementById('model').Value = "";
        setVINDisableFlag(false)
        setVINInvalidError("");
    }
    const vinnumberChecking = (value) => {
        let request = {
            vin_no: value,
        }
        API.post("vinnumberCheck/condition", request).then(response => {
            console.log("vin number cheking response", response.data.success)
            setVinNoChecking(response.data.data[0]);
        });
    }

    const searchVIN = (e) => {
        console.log("myVINNumber=====", VINNumber)
        setVINInvalidError("")
        setVINDisableFlag(false)
        // setVINNumber("")
        // SetSalesIdError("")
        // if ( !VINNumber) {
        //     setDecodeError("Decode is Required")
        //     return;
        // }
        if (!VINNumber) {
            setVINInvalidError("VIN Number is Required")
            return;
        }
        if (vinNoChecking) {
            setVINInvalidError("This VIN Number already exist")
            return;
        }

        if (carDataList.length > 0 && carDataList.filter(data => data.vin_no === VINNumber).length > 0) {
            setVINInvalidError("This VIN Number already exist, Please enter Unique VIN Number")
            setVINDisableFlag(false)
            return;
        }

        if (VINNumber.indexOf('I') > -1 || VINNumber.indexOf('O') > -1 || VINNumber.indexOf('o') > -1 || VINNumber.indexOf('i') > -1) {
            toggleCommonPopup()
            setPopupTitle("Error");
            setPopupMsg("Vin Number Not Accepted I and O ");
            setPopupType("error");
            setPopupActionType("close");
            setPopupActionValue("ok");
        }
        else {
            if (VINNumber !== "") {
                API.get(`https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/${VINNumber}?format=json`)
                    .then(res => {
                        setVINInvalidError("")
                        setVINDisableFlag(false)
                        console.log("check api", res);
                        console.log("rrrr===", res.data.Results)
                        const carmodel = res.data.Results.filter(carModel => carModel.Variable === "Model")[0]
                        if (carmodel.Value !== "" && carmodel.Value !== null) {
                            setVINDisableFlag(true)
                            setBidAndDayFlag(true)
                            setModel(carmodel.Value)
                            setModelFun(carmodel.Value)
                            const carmake = res.data.Results.filter(carMake => carMake.Variable === "Make")[0]
                            setMake(carmake.Value)
                            setMakeFun(carmake.Value)
                            const caryear = res.data.Results.filter(carYear => carYear.Variable === "Model Year")[0]
                            setYear(caryear.Value)
                            setYearFun(caryear.Value)
                            const newChanges = [];
                            const length = carDataList.length
                            if (VINNumber !== "") {
                                newChanges.push({ oldvalue: "", newvalue: VINNumber, name: "Vin #", id: `car${length}`, flag: "Add" });
                            }
                            setChangesArray([...changesArray, ...newChanges]);
                            setCarDataList([...carDataList, { vin_no: VINNumber, model: carmodel.Value, make: carmake.Value, year: caryear.Value, sales_type_id: "", no_of_days: "" }])
                            // const updatedCarDataList = carDataList.map((carData, index) => {
                            //     if (index < carCount) {
                            //         return {
                            //             ...carData,
                            //             vin_no: VINNumber, model: carmodel.Value, make: carmake.Value, year: caryear.Value, sales_type_id: "", no_of_days: ""
                            //         };
                            //     }
                            //     return carData;
                            // });

                            const updatedCarDataList = [...carDataList];
                            const emptyArrayIndex = updatedCarDataList.findIndex(carData => carData.vin_no === "" && carData.model === "" && carData.make === "" && carData.year === "");
                            if (emptyArrayIndex !== -1) {
                                updatedCarDataList[emptyArrayIndex] = {
                                    vin_no: VINNumber, model: carmodel.Value, make: carmake.Value, year: caryear.Value, sales_type_id: "", no_of_days: ""
                                };
                            }
                            // setCarDataList(updatedCarDataList);
                        } else {
                            setModel("")
                            setMake("")
                            setYear("")
                            setVINInvalidError("please Enter Valid VIN Number");
                            setVINDisableFlag(false)
                        }
                    })
                    .catch(err => { console.log(err); setVINDisableFlag(false); });
            }
        }
    }
    const addNewCarData = () => {
        console.log("addNewCarData")
        setBidAndDayFlag(false)
        setDecodeError("")
        SetSalesIdError("")
        setNoOfDaysError("")
        setVINNumber1("")
        setVINNumber("")
        setSelectedBid("")
        setSelectedDays("")
        document.getElementById("vinNo").value = ""
        setVINNumber("")
        setModel("")
        setMake("")
        setYear("")
        setComments("");
        // SetSalesId("")
        // document.getElementById("dropBids").value = "-- Select Bids --"
        // setSelectDays("")
        setSelectedDays("")
        setChangesArray(changesArray.filter(data => data.name !== "Comments"))

        setVINDisableFlag(false)
        if (!VINNumber || year == "" && make == "" && model == "" && VINNumber.length > 0) {
            setDecodeError("Decode is Required")
            return;
        }
        // if (!selectedBid && VINNumber1 || (!selectedBid && !selectedDays)) {
        //     SetSalesIdError("Bids is required")
        //     return
        // } else if (!selectedDays && VINNumber1 || (selectedBid && !selectedDays)) {
        //     setNoOfDaysError("No Of days is required")
        //     return
        // }

        if (selectedBid || VINNumber === "") {
            setSelectedBid("")
            SetSalesIdError("")
        }

        if (selectedDays || VINNumber === "") {
            setSelectedDays("")
            setNoOfDaysError("")
        }


        if (VINNumber !== "" || year !== "" || model !== "" || make !== "") {
            if (carDataList.filter(data => data.vin_no === VINNumber && data.model === model && data.make === make && data.year === year).length > 0) {
                setVINInvalidError("");
            }
            else if (carDataList.filter(data => data.vin_no !== "" && data.vin_no === VINNumber).length) {
                setVINInvalidError("This VIN Number already exist, Please enter Unique VIN Number")
            }
            else {
                setCarDataList([...carDataList, { vin_no: VINNumber, model: model, make: make, year: year, sales_type_id: "", no_of_days: "" }])
                setVINInvalidError("");
            }
            // if (!salesId) {
            //     SetSalesIdError("Bids is required")
            //     return;
            // }
            // if (!selectDays) {
            //     setNoOfDaysError("No Of Days is required")
            //     return;
            // }
            // if (!selectedBid && VINNumber.length > 0) {
            //     SetSalesIdError("Bids is required")
            //     console.log(selectedBid, "salesId")
            //     return;
            // }
            // else if(selectedBid){
            //     SetSalesIdError("")  
            // }
            // if (!selectedDays && VINNumber.length > 0) {
            //     setNoOfDaysError("No Of days is required")
            //     console.log(selectedDays, carDataList.length, "salesId selectDays")
            //     return;
            // }
            // else if(selectedDays){
            //     setNoOfDaysError("")  
            // }
        }

    }

    const onKeydowninSearch = (e) => {
        if (e.key === 'Enter') {
            console.log('Enter is pressed call search function');
            VINNumber(e.key === "i") && VINNumber(e.key === "i")
        }
    }

    const removeRow = (vin_no, index) => {
        setCarDataList(carDataList.filter(data => data.vin_no !== vin_no))

        let remainingArrays = changesArray.filter(obj => obj.id !== `car${index}`);
        const updatedObjects = remainingArrays.map(obj => {
            const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
            if (numericPart > index) {
                return { ...obj, id: obj.id.startsWith('car') ? `car${numericPart - 1}` : obj.id };
            }
            return obj;
        });
        setChangesArray([...updatedObjects]);
    }
    const setYearFun = (data) => {
        setYear(data)
    }
    const setMakeFun = (data) => {
        setMake(data)
    }
    const setModelFun = (data) => {
        setModel(data)
    }

    const ChangeVIN = (e) => {
        console.log("ChangeVIN");
        setVINNumber(e.target.value.trim());
        setVINNumber1(e.target.value)
        vinnumberChecking(e.target.value)
    }


    const handleBidChange = (e) => {

        setSelectedBid(e.target.value);
        const newCarDataList = carDataList.map((carData) => {
            if (carData.vin_no === VINNumber) {
                const newChanges = [];
                const length = carDataList.length
                if (e.target.value !== "") {
                    newChanges.push({ oldvalue: "", newvalue: e.target.value, name: "Sales type", id: `car${length - 1}`, flag: "Add" });
                }
                setChangesArray([...changesArray, ...newChanges]);
                return { ...carData, sales_type_id: e.target.value };
            } else {
                return carData;
            }
        });
        setCarDataList(newCarDataList);
    }

    const handleDaysChange = (e) => {
        setSelectedDays(e.target.value);
        const newCarDataList = carDataList.map((carData) => {
            if (carData.vin_no === VINNumber) {
                const newChanges = [];
                const length = carDataList.length
                if (e.target.value !== "") {
                    newChanges.push({ oldvalue: "", newvalue: e.target.value, name: "Select Days", id: `car${length - 1}`, flag: "Add" });
                }
                setChangesArray([...changesArray, ...newChanges]);
                return { ...carData, no_of_days: e.target.value };
            } else {
                return carData;
            }
        });
        setCarDataList(newCarDataList);
    }
    console.log("request carData lists", carDataList);

    const handleCount = (e) => {

        const newValue = e.target.value;
        const oldvalue = "";
        setCarCount(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'How many cars');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'How many cars' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'How many cars' };
            setChangesArray([...changesArray, change]);
        }
    }
    const Clearhistory = () => {
        const filteredData = changesArray.filter(item => !["State", "City", "Zipcode", "Address"].includes(item.name));
        setChangesArray(filteredData)

    }

    const handleAddress = (e) => {

        const newValue = e.target.value;
        const oldvalue = "";
        setAddress(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Address');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Address' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Address' };
            setChangesArray([...changesArray, change]);
        }
    }
    const handleComments = (e) => {

        const newValue = e.target.value;
        const oldvalue = "";
        setComments(newValue);
        const existingChangeIndex = changesArray.findIndex(change => change.name === 'Comments');
        if (existingChangeIndex !== -1) {
            const updatedChangesArray = [...changesArray];
            updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'Comments' };
            setChangesArray(updatedChangesArray);
        } else {
            const change = { oldvalue, newvalue: newValue, name: 'Comments' };
            setChangesArray([...changesArray, change]);
        }
    }
    return (
        <div>
            {loading ? <Loading /> :
                <main id="main" className="inner-page">
                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div id="fees" className="fees">
                            <div className="container-fluid inner-page-space aos-init aos-animate" data-aos="fade-up">

                                <div className="feesblock col-lg-12 ">
                                    <div class="back-btn">
                                        <a class="back-btn-primary" onClick={() => history.push("/urpostlist")}><i class="bx bx-chevron-left"></i> Back</a>
                                    </div>
                                    <form className="urpost" >
                                        <h2 className="title"> URPOST</h2>
                                        <div className="row">
                                            <div className="col-lg-12 form-group howmanycars">
                                                <div className="tbox">
                                                    <input className="textbox" type="text" name="carCount" id="carCount" placeholder="" defaultValue={carCount}
                                                        onChange={handleCount} />
                                                    <label htmlFor="carCount" className={carCount != "" ? "input-has-value" : ""}>How many cars</label>
                                                </div>
                                                <p className="form-input-error1" >{carCountError}</p>
                                            </div>
                                            <div className="col-lg-6 same-address">
                                                <div className="radio input-group">
                                                    <input id="radio1" name="radio" type="radio" checked={switchAddress === "same" ? true : false} value={"same"}
                                                        onChange={(e) => { setSwitchAddress(e.target.value); Clearhistory() }} />
                                                    <label htmlFor="radio1" className="radio-label">Same Address</label>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 same-address">
                                                <div className="radio input-group">
                                                    <input id="radio2" name="radio" type="radio" checked={switchAddress === "dif" ? true : false} value={"dif"}
                                                        onChange={(e) => { setSwitchAddress(e.target.value); Clearhistory() }} />
                                                    <label htmlFor="radio2" className="radio-label">Different Address</label>
                                                </div>
                                            </div>
                                            {/* ======== */}
                                            <div className="col-lg-12 addressrow" style={{ "display": `${switchAddress}` === "dif" ? "none" : "block" }}>
                                                <div className="tbox">
                                                    <input disabled className="textbox" type="text" name="addr" id="addr" placeholder="" value={sellerData.address} />
                                                    <label htmlFor="addr" className="input-has-value">Address</label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4" style={{ "display": `${switchAddress}` === "dif" ? "none" : "block" }}>
                                                <div className="tbox">
                                                    <input disabled className="textbox" type="text" name="state" id="state" placeholder="" value={currentState} />
                                                    <label htmlFor="addr" className="input-has-value">State</label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4" style={{ "display": `${switchAddress}` === "dif" ? "none" : "block" }}>
                                                <div className="tbox">
                                                    <input disabled className="textbox" type="text" name="city" id="city" placeholder="" value={currentCity} />
                                                    <label htmlFor="addr" className="input-has-value">City</label>
                                                </div>
                                            </div>
                                            <div className="col-lg-4" style={{ "display": `${switchAddress}` === "dif" ? "none" : "block" }}>
                                                <div className="tbox">
                                                    <input disabled className="textbox" type="text" name="zip" id="zip" placeholder="" value={currentZip} />
                                                    <label htmlFor="addr" className="input-has-value">Zipcode</label>
                                                </div>
                                            </div>
                                            {/* --- */}
                                            <div className="col-lg-12" style={{ "display": `${switchAddress}` === "same" ? "none" : "block" }}>
                                                <div className="tbox">
                                                    <input className="textbox" type="text" name="addr" id="addrr" placeholder=""
                                                        onChange={handleAddress} />
                                                    <label htmlFor="addrr" className={address != "" ? "input-has-value" : ""}>Address</label>
                                                    <p className="form-input-error" >{addressError}</p>
                                                </div>
                                            </div>

                                            {switchAddress !== "same" &&
                                                <>
                                                    <StateAndCitySearch
                                                        // setStateValue={getStateName}
                                                        // setCityValue={getCityName}
                                                        // setZipcodeValue={getZipCodeId}
                                                        setStateValue={(stateData, flag) => getStateName(stateData, flag, 'State')}
                                                        setCityValue={(cityData, flag) => getCityName(cityData, flag, 'City')}
                                                        setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'Zipcode')}
                                                        setNewError={getError}
                                                        stateCityValidation={stateAndCityError}

                                                    />
                                                </>
                                            }

                                            <div className="col-lg-12">
                                                <div className="add-accounts">
                                                    <a disabled={carDataList.length >= carCount ? true : false} className="add-account-btns" href="JavaScript:void(0)" onClick={() => { carDataList.length < carCount && addNewCarData() }} >+ Add Another Car</a>
                                                </div>
                                            </div>
                                            <div className="col-lg-9 form-group searchVinNo">
                                                <div className="tbox">
                                                    <input disabled={VINDisableFlag} className="textbox" type="text" name="dname" id="vinNo" placeholder=""
                                                        onChange={(e) => ChangeVIN(e)} />
                                                    <label htmlFor="vinNo" className={VINNumber != "" ? "input-has-value" : ""}>Enter your VIN Number</label>
                                                </div>
                                                <p className="form-input-error1" >{DecodeError}</p>
                                                <p className="form-input-error1" >{VINInvalidError}</p>
                                            </div>
                                            <div className="col-lg-3 form-group searchVinNo">
                                                <button class="btn btn-outline-secondary rounded-1 searchdecode" type="button"
                                                    disabled={(carCount > 0 && carDataList.length >= carCount) || VINNumber.length < 6 ? true : false}
                                                    onClick={() => { !VINDisableFlag && searchVIN(); setDecodeError("") }}
                                                > Decode</button>
                                            </div>
                                            <div className="col-lg-12 form-group">
                                                <div className="tbox">
                                                    <input disabled={VINDisableFlag} className="textbox" type="text" name="Year" id="Year" placeholder="" value={year}
                                                        onChange={(e) => setYearFun(e.target.value)} />
                                                    <label htmlFor="Year" className={year != "" ? "input-has-value" : ""}>Year</label>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 form-group">
                                                <div className="tbox">
                                                    <input disabled={VINDisableFlag} className="textbox" type="text" name="lname" id="Make" placeholder="" value={make}
                                                        onChange={(e) => setMakeFun(e.target.value)} />
                                                    <label htmlFor="Make" className={make != "" ? "input-has-value" : ""}>Make</label>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 form-group">
                                                <div className="tbox">
                                                    <input disabled={VINDisableFlag} className="textbox" type="text" name="phone" id="Model" placeholder="" value={model}
                                                        onChange={(e) => setModelFun(e.target.value)} />
                                                    <label htmlFor="Model" className={model != "" ? "input-has-value" : ""}>Model</label>
                                                </div>
                                            </div>
                                            {bidAndDayFlag === true ?
                                                <>
                                                    <div className="col-lg-12 form-group">
                                                        <div className="tbox">
                                                            <select id="dropBids" placeholder="" name="dropBids" className="form-control" value={selectedBid || ""} disabled={VINDisableFlag === false}
                                                                onChange={handleBidChange}>
                                                                <option style={{ "display": "none" }}>-- Sales type --</option>
                                                                <option value="3">Auction</option>
                                                                <option value="2" >Make Bid</option>
                                                                <option value="1">Sealed Bids</option>
                                                            </select>

                                                        </div>
                                                        <p className="form-input-error1" >{SalesIdError}</p>

                                                    </div>
                                                    <div className="col-lg-12 form-group">
                                                        <div className="tbox">
                                                            <select id="cardays" placeholder="" name="cardays" className="form-control" value={selectedDays || ""} disabled={VINDisableFlag === false}
                                                                onChange={handleDaysChange} >
                                                                <option style={{ "display": "none" }}>-- Select Days --</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                                <option value="6">6</option>
                                                                <option value="7">7</option>
                                                            </select>
                                                        </div>
                                                        <p className="form-input-error1" >{noOfDaysError}</p>
                                                    </div>
                                                </>
                                                : ""}

                                            <div className="col-lg-12 form-group">
                                                <div className="tbox">
                                                    <textarea className="form-control" type="text" name="Comments" id="Comments" placeholder="Comments" value={comments}
                                                        onChange={handleComments} />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 loginBtn">
                                                <Button className="cta-btn" style={customButtonStyle} onClick={handleSubmit1} >Submit</Button>
                                            </div>




                                            <div className="col-sm-12 urpostTable urposttable">
                                                {carDataList.length > 0 && 
                                                <div class="table-responsive">
                                                <div className="urposttable">
                                                <table>
                                                    <thead>
                                                        <th>VIN #</th>
                                                        <th>Model</th>
                                                        <th>Make</th>
                                                        <th>Year</th>
                                                        <th className='urpost-action'>Remove</th>
                                                    </thead>
                                                    <tbody>

                                                        {carDataList.map((carList, index) =>
                                                            <tr>
                                                                <td>{carList.vin_no}</td>
                                                                <td>{carList.model}</td>
                                                                <td>{carList.make}</td>
                                                                <td>{carList.year}</td>
                                                                <td  className='action-right-fix-list-urpost' onClick={() => removeRow(carList.vin_no, index)}><img src={RemoveIcon} className='removeicon' ></img></td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                </div>
                                                </div>}
                                            </div>


                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>}
                    {confirmationFlag &&

                        <>
                            <Modal show={true} onHide={confirmationPopup} centered>
                                <Modal.Header className="Terms-login">
                                    <h2>Edit confirmation</h2>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="CommonModalbody">

                                        <p>Are you sure,If you want to Add Car Information please confirm</p>
                                    </div>

                                    <div className="col-md-12 btns confirmation">
                                        <button className="cta-btns" onClick={confirmationPopup} >CANCEL</button>
                                        <button className="cta-btns" onClick={handleSubmit} >OK</button>
                                    </div>

                                </Modal.Body>
                            </Modal>
                        </>}
                    <section id="playstoreBlock" className="playstoreBlock">
                        <div className="container">
                            <div className="row content">
                                <div className="col-lg-12">
                                    <img src={appstore} />
                                    <img src={googleplay} />
                                </div>
                            </div>
                            {open &&
                                <CommonPopup
                                    handleClose={toggleCommonPopup}
                                    popupTitle={popupTitle}
                                    popupMsg={popupMsg}
                                    popupType={popupType}
                                    popupActionType={popupActionType}
                                    popupActionValue={popupActionValue}
                                    popupActionPath={popupActionPath}
                                />}
                        </div>
                    </section>
                    {isOpen &&
                        <CommonPopup
                            handleClose={togglePopup}
                            popupTitle={popupTitle}
                            popupMsg={popupMsg}
                            popupType={popupType}
                            popupActionType={popupActionType}
                            popupActionValue={popupActionValue}
                            popupActionPath={popupActionPath}
                        />}
                </main>}
        </div>
    )
}

export default URpost